import React from 'react';
import Container from '@mui/material/Container';
import { Link, Navigate } from 'react-router-dom';
import { hasUser } from '../../utils/cookies';
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import AuthMenuComponent from "../../components/menu/authMenu";
import Alert from '@mui/material/Alert';
import Snackbar from "@mui/material/Snackbar";
import {SBBBackDropBlueLoader} from "../../components/common/loader/circularLoader";
import Button from "@mui/material/Button";
import useClasses from "../../utils/themeUtils";
import {SbbFormControl, SbbInput, SbbLabel} from "../../components/common/inputs/sbbInput";
import './login.scss';
import {DASHBOARD} from "../../utils/navigation";
import variables from "../../css/theme.module.scss";
import Btn from "@mui/material/Button/Button";

const useStyles = theme => ({
    root: {
        flexGrow: 1,
    },
    loginForm: {
        flexGrow: 1,
        height: 'calc(100vh - 170px)',
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },
});

const LoginView = (props) => {
    const classes = useClasses(useStyles);

    return (
        <div className='login-container background-dark-img'>

            <Container maxWidth="md" sx={{p:0}}>
                <AuthMenuComponent />

                {(hasUser()) ? <Navigate to={props.redirect ? props.redirect : DASHBOARD }></Navigate> : null}

                {(!props.success && props.message && props.snackbar_open) ?
                    <Snackbar open={props.snackbar_open} autoHideDuration={6000} onClose={props.handleSnacks}>
                        <Alert elevation={6} variant="filled" severity="error" onClose={props.handleSnacks}>
                            {props.message}
                        </Alert>
                    </Snackbar>
                    : null}

                <form onSubmit={props.handleLogin} className='login-form'>
                    <Grid container className={classes.loginForm} spacing={0}
                          justifyContent="center"
                          alignItems="center">
                        <Grid item
                              container
                              className="paper-white-block"
                              direction="column"
                              gap={3}
                              p={{xs:2,sm:3,md:4,lg:4,xl:4}}
                              xs={11} sm={9} md={7} lg={7}>
                                <Grid item container justifyContent={{xs:'start', sm: 'start', md: 'center'}}>
                                    <h1 className='text-dark'>Login</h1>
                                </Grid>
                                <Box >
                                    <SbbFormControl fullWidth variant="standard">
                                        <SbbLabel shrink htmlFor="username">
                                            Email *
                                        </SbbLabel>
                                        <SbbInput placeholder="Email"
                                                  id="username"
                                                  required
                                                  fullWidth />
                                    </SbbFormControl>
                                </Box>
                                <Box >
                                    <SbbFormControl fullWidth variant="standard">
                                        <SbbLabel shrink htmlFor="password">
                                            Password *
                                        </SbbLabel>
                                        <SbbInput placeholder="Password"
                                                  id="password"
                                                  type="password"
                                                  required
                                                  fullWidth />
                                    </SbbFormControl>
                                    <Link to='/forgot' className="small-link-nav" >Forgot your password?</Link>

                                </Box>
                                <Box >
                                    <Button type="submit" variant="contained" fullWidth>Login</Button>
                                </Box>
                                <Box display="flex" justifyContent={{xs:'start', sm: 'start', md: 'center'}} direction="row">
                                    <p className="text-dark">
                                        Don't have an account? &nbsp;
                                        <Link to={'/get-started'}
                                              style={{fontFamily: variables.Avenir, fontWeight: '500', textDecoration: 'none',}}>
                                            Sign Up
                                        </Link>
                                    </p>
                                </Box>
                        </Grid>
                    </Grid>
                    </form>
            </Container>
            <SBBBackDropBlueLoader open={props.loading}/>
        </div>
    );
};

export default LoginView;
